var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "klienticta w-inline-block flex-column d-flex align-items-center pointer",
    on: {
      "click": _vm.openTestimonialInvoicePopup
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": require("@/images/invoice-icon.svg"),
      "width": "22px"
    }
  }), _c('span', {
    staticClass: "bl-color"
  }, [_vm._v("faktúra")])]);

}
var staticRenderFns = []

export { render, staticRenderFns }